// Maaz A : 27-02-2023 : BT-96728 - Breeze - Global Search Feature - Start
import { memo, useCallback, useEffect, useState, useMemo, useRef, useLayoutEffect } from 'react';
import { BzButton, BzInputText } from '../../components';//BT-96728 - Global Search Feature : ManasaB : 22/07/2023
import { TabsScripsList } from './';
import { Col, Row, Container } from 'react-bootstrap';
import { isUserIsAGuest, WATCHLIST_GRID_REF, getAppInfoData, getDecryptLocalStorage, getMappedMktSegIdFromApiExchangeName, hamburgerRoutes, setEncryptLocalStorage, getMktSegIdFromMappedMktSegId, convertScripResponseWatchlistGrid, getDynamicParamsForToFixed, getApiExchangeNameFromMktSegId, ORDER_ENTRY_GRID_REF, handleClickOnModernAlgo } from '../../utils/global_functions';
import { toastConfig } from '../../redux/actions/toast';
import { selectScripForDelete } from '../../redux/actions/watchlist';
import { _resetGridFeatures } from '../../controllers/watchlist';
import { GLOBAL_SEARCH_MIN_LENGTH, WATCHLIST_GRID_INDEX, DASHBOAR_WALKTHROUGH_POPOVER_SEQUENCE, APP_INFO_PARAMS, ORDER_PRODUCT_TYPES, SIDE_TRAY_EXPAND_PERCENTAGE, APP_INFO_DEFAULT_VALUES, TRADING_NOT_ALLOWED_MSG, ORDER_ENTRY_BUTTON_TOGGLE, ORDER_ENTRY_TYPES, FACILITY_NUM, } from '../../utils/global_variables';
import { useDebounce } from '../../hooks';
import { getSearchScrips, updateSearchScripDataStatusFailure, setArrScripToBeAdded, updateIsLoading, setArrTrending, setArrRecentlySearchScrips } from '../../redux/actions/globalSearch';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Walkthrough } from '../Help';
import { handleModal, handleModalData } from '../../redux/actions/modals';
//BT-114442,BT-114264 : Option tab functionality,Showing trending scrips in search : ManasaB : 11/08/2023 - Start
import TrendingSearch from './TrendingSearch';
import { hotPursuitData } from '../../redux/actions/news';
//BT-114442,BT-114264 : Option tab functionality,Showing trending scrips in search : ManasaB : 11/08/2023 - End
import RecentSearch from './RecentSearch';//BT-96728 - Global Search Feature : ManasaB : 22/07/2023
import { getScripOrderInfo, getExchangeWiseScripInfo, getSpreadOrder, updateIsBuyOrSell } from '../../redux/actions/orders';
import { setScripOverviewData, updateActiveOverViewTab } from '../../redux/actions/marketOverview';
import { _checkSegmetAllowed, _getIsUserAllowedBracketCover } from '../../controllers/orders';
import { getScripbyTokenAndMktSegId } from '../../apis';
import useAnalyticsEventTracker from '../../hooks/useAnalyticsEventTracker';
const jtenantToken = 1;//BT-114264 : Showing trending scrips in search : ManasaB : 11/08/2023

const GlobalSearch = ({ isExpanded = { isTrue: false, containerLength: '0%' }, globalSearchRef, setNActiveCategory, setIsExpanded, setIsSideBar, setTabSearchToggle, show, setShow, activeButtonToggleIndex, setActiveButtonToggleIndex, market, setMarket }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    //BT-114264 : Showing trending scrips in search : ManasaB : 11/08/2023  - Start
    const modals = useSelector(state => state.modals.modals);
    let nItems = getAppInfoData(APP_INFO_PARAMS.APP_HOTPURSUIT_SCRIP_COUNT, APP_INFO_DEFAULT_VALUES.HOTPURSUIT_SCRIP_COUNT);

    //BT-114264 : Showing trending scrips in search : ManasaB : 11/08/2023  - End
    // globalScripDetails is array consist of scrips added from global search
    // addGlobalScrips is function click on plus icon in search scrip listing
    // removeGlobalScrips is function click on minus icon in search scrip listing
    const [globalScripDetails, setGlobalScripDetails] = useState([]);
    const [isSearchScrips, setIsSearchScrips] = useState(false);
    //BT-96728 - Global Search Feature : ManasaB : 22/07/2023 - Start
    const [isExpand, setIsExpand] = useState(false);
    const [strGlobalSearchInputText, setStrGlobalSearchInputText] = useState('');
    // const [isData,setIsData] = useState(true) ;//Added to hide nodata content when eq,fut and opt data not there
    const [strGlobalSearchActiveTab, setStrGlobalSearchActiveTab] = useState('equity'); //BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023
    //BT-114442,BT-114264 : Option tab functionality,Showing trending scrips in search : ManasaB : 11/08/2023 - Start
    const arrHotPursuitData = useSelector(state => state?.news?.arrHotPursuitData);
    //BT-114442,BT-114264 : Option tab functionality,Showing trending scrips in search : ManasaB : 11/08/2023 - End



    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const [bIsCoverOrderAllowed, bIsBracketOrderAllowed] = useMemo(() => _getIsUserAllowedBracketCover(objLoginSession).data, [objLoginSession]);
    const arrRecentlySearchScrips = useSelector(state => state.globalSearch.arrRecentlySearchScrips);
    const arrTrending = useSelector(state => state.globalSearch.arrTrending);
    //Vaibhav Singh: 23-11-23: GlobalSearch Leftclick ScripOverview implemented: Start
    const [modalOpen, setModalOpen] = useState(false);
    //Vaibhav Singh: 23-11-23: GlobalSearch Leftclick ScripOverview implemented: End
    const objCFT = useSelector(state => state?.auth?.objCFT);
    const getEvent = useAnalyticsEventTracker("GLOBAL_SEARCH_LOOKUP");

    useEffect(() => {
        const localStorageKey = "RECENTLY_SEARCHED";
        const searchArray = getDecryptLocalStorage(localStorageKey);
        if (searchArray) {
            const parsedArray = JSON.parse(searchArray); // Hari k:14-02-2024 to show usef specific recent search
            let objActiveUserRecentSearch = parsedArray?.find((each) => each?.user_id === objLoginSession?.data?.user_id);
            dispatch(setArrRecentlySearchScrips(objActiveUserRecentSearch));
        } else { }
    }, []);
    //Vaibhav Singh: 23-11-23: GlobalSearch Leftclick ScripOverview implemented: Start
    useEffect(() => {
        setModalOpen(Object.keys(modals)?.some(k => modals[k]));
    }, [modals]);
    const wrapperRef = useRef(null);

    useEffect(() => {
        const clickFunction = (event) => {
            if (!wrapperRef?.current?.contains(event.target) && !modalOpen) {
                setGlobalScripDetails([]); // Hari k:09-02-2024: to make discart selected scrips
                setShow(false);
                setIsExpand(false);
            }
        };
        document.addEventListener('mousedown', clickFunction);
        return () => {
            document.removeEventListener('mousedown', clickFunction);
        };
    }, [modalOpen]);
    //Vaibhav Singh: 23-11-23: GlobalSearch Leftclick ScripOverview implemented: End
    useEffect(() => {
        const escFunction = (event) => {
            if (event.key === "Escape") {
                setGlobalScripDetails([]); // Hari k:09-02-2024: to make discart selected scrips
                setShow(false);
                setIsExpand(false);
            }
        };
        document.addEventListener('keydown', escFunction);
        return () => {
            document.removeEventListener('keydown', escFunction);
        };
    }, []);
    const handleExpand = useCallback(() => {
        setIsExpand(prevState => !prevState);
    }, []);

    const saveToLocalStorage = (arrScripUpdated) => {
        setEncryptLocalStorage('RECENTLY_SEARCHED', JSON.stringify(arrScripUpdated));
    };
    //BT-114264 : Showing trending scrips in search : ManasaB : 11/08/2023  - Start

    useEffect(() => {
        if (isExpand) dispatch(hotPursuitData(nItems, jtenantToken)); //Ameersha given condition to call only when global search is opened instead just showing magnifier icon
    }, [isExpand]);

    const handleTrending = () => {

        let arrTrendingScripsTemp = [];
        if (arrHotPursuitData.length > 0) {
            for (let index = 0; index < arrHotPursuitData.length; index++) {
                let element = arrHotPursuitData[index];
                if (element.symbol !== undefined) {
                    arrTrendingScripsTemp.push(element.symbol);
                }
            }
            dispatch(setArrTrending([...arrTrendingScripsTemp]));
        }
    };
    //BT-114264 : Showing trending scrips in search : ManasaB : 11/08/2023  - End

    const handleEditAlert = (data) => {
        dispatch(handleModalData({
            AlertData: {
                symbol: data?.symbol,
                exchange: data?.exchange,
                series: data?.series,
                description: data?.securityDesc,
                token: data?.nToken,
                mktId: data?.segmentId,
                decimalLocator: data?.decimalLocator,
                decimalLocator_length: getDynamicParamsForToFixed(data?.exchange),
                exchange_segement: getApiExchangeNameFromMktSegId(data?.segmentId)
            }, modifyData: data, isEditable: true
        }));
        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
        setShow(false);
    };

    const handleOnClickScrip = (arrScripData) => {
        if (arrRecentlySearchScrips?.length > 0) {
            let nIndex = arrRecentlySearchScrips.findIndex(eachScrip => eachScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrScripData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            if (nIndex !== -1) {
                if (nIndex > 0) {
                    arrRecentlySearchScrips.splice(nIndex, 1);
                    const updatedArray = [arrScripData, ...arrRecentlySearchScrips];
                    setArrRecentlySearchScrips(updatedArray);
                    saveToLocalStorage(updatedArray);
                }
                else { }
            }
            else {
                const updatedArray = [arrScripData, ...arrRecentlySearchScrips];
                setArrRecentlySearchScrips(updatedArray);
                saveToLocalStorage(updatedArray);
            }
        }
        else {
            const localArray = [...arrRecentlySearchScrips, arrScripData];
            setArrRecentlySearchScrips(localArray);
            saveToLocalStorage(localArray);

        }
    };

    const addGlobalScrips = useCallback((e, scrip) => {
        // dispatch(setArrScripToBeAdded([...arrScripsToBeAdded, scrip]));
        setGlobalScripDetails(prevState => ([...prevState, scrip]));
    }, []);

    const addGlobalScripsFromRecent = useCallback((e, scrip) => {
        dispatch(setArrScripToBeAdded([...globalScripDetails, scrip]));
        setShow(false);
        dispatch(handleModal([{ "GLOBAL_SEARCH_ADDSCRIP_MODAL": true }]));
        setGlobalScripDetails([]);
    }, [globalScripDetails, setShow, dispatch]);

    const removeGlobalScrips = useCallback((e, scrip) => {
        const arrCurrScripDetails = globalScripDetails;
        const nIndex = arrCurrScripDetails.findIndex(each => each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
        if (nIndex >= 0) {
            arrCurrScripDetails.splice(nIndex, 1);
        } else { }
        // dispatch(setArrScripToBeAdded([...arrCurrScripDetails]));
        setGlobalScripDetails([...arrCurrScripDetails]);
    }, [globalScripDetails]);

    const handlePlaceOrder = useCallback((orderInfo, nIsBuyOrSell) => {
        ORDER_ENTRY_GRID_REF.current.setIsScripPrice(false);
        dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: orderInfo[WATCHLIST_GRID_INDEX.EXCHANGE], scripData: orderInfo }));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
    }, [dispatch]);

    // Ameersha N : 14-12-2023 : BT-96728 Global Search feature -Start
    const handleSelectSpreadOrderModel = (spreadArr, strBuySell) => {
        dispatch(updateIsBuyOrSell(strBuySell));//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API
            "symbol": spreadArr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": spreadArr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        dispatch(getSpreadOrder(spreadPaylod));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
        const objScrpinfo = { activeExchangeId: '', isBuySell: 0, scripData: spreadArr };
        dispatch(getScripOrderInfo(objScrpinfo));
        dispatch(handleModalData({ data: { spreadArr: spreadArr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
    };
    // Ameersha N : 14-12-2023 : BT-96728 Global Search feature -Start
    const onBuySellClick = useCallback((strBuySell, arrRowData) => {
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            getEvent(!isSearchScrips ? `${strBuySell.toUpperCase() === 'BUY' ? "B" : "S"}_LOOKUP_RECENT` : `${strBuySell.toUpperCase() === 'BUY' ? "B" : "S"}_LOOKUP`);
            if (_checkSegmetAllowed(arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE_SEGMENT], objLoginSession?.data?.exchanges)) {
                if (setShow) {
                    setShow(false); //To close global search when place order modal is open : Manasa B : 24/08/2023
                } else { }
                if (arrRowData[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                    //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - Start
                    if (objCFT?.MULTILEG) {
                        handleSelectSpreadOrderModel(arrRowData, strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
                    } else {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Currently you are not allowed to place orders in Multileg .` }));
                    }
                    //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - End
                } else {
                    handlePlaceOrder(arrRowData, strBuySell.toUpperCase() === 'BUY' ? ORDER_ENTRY_BUTTON_TOGGLE.BUY : ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                    setMarket(arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]);
                    dispatch(getExchangeWiseScripInfo(arrRowData));
                }
                // Ameersha N : 07-11-2023 : BT-96728 Global Search feature – Issue - addedScrips state not getting empty  – Start
                setGlobalScripDetails([]);
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: TRADING_NOT_ALLOWED_MSG }));

            }
            // Ameersha N : 07-11-2023 : BT-96728 Global Search feature – Issue - addedScrips state not getting empty  – Start
        } else { } //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End

    }, [handlePlaceOrder, handleSelectSpreadOrderModel, setMarket, setShow, activeButtonToggleIndex]);

    const onBuySellClickRecomm = useCallback((strBuySell, arrRowData) => {
        if (setShow) {
            setShow(false); //To close global search when place order modal is open : Manasa B : 24/08/2023
        } else { }
        if (arrRowData[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
            handleSelectSpreadOrderModel(arrRowData, strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
        } else {
            const objScrpinfo = { activeExchangeId: arrRowData?.scripInfo[WATCHLIST_GRID_INDEX.SEGMENT_ID], isBuySell: strBuySell.toUpperCase() === "BUY" ? 0 : strBuySell.toUpperCase() === "SELL" ? 1 : '', scripData: [...arrRowData?.scripInfo] };
            dispatch(getScripOrderInfo(objScrpinfo));

            dispatch(getExchangeWiseScripInfo(objScrpinfo.scripData));
            handleRecommendationDataWithOrderInputs(arrRowData, undefined);
            dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
            if (setMarket) {
                setMarket(arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]);
            } else { }


        }
    }, [handleSelectSpreadOrderModel, setMarket, setShow, activeButtonToggleIndex]);



    const handleRecommendationDataWithOrderInputs = useCallback((rmdDetails, i) => {
        //for follow-up BUY/SELL
        let iIndex = 0;
        let productType = "";
        let orderType = '';
        let productTypeDesc = '';
        if (i !== undefined && i != null && i !== '') {
            iIndex = i;
        }

        if (rmdDetails && parseFloat(rmdDetails?.sRecoDetails[iIndex].OrderCount) >= 0) {
            if (rmdDetails.sRecoDetails[iIndex].nBuySell === 'BUY') {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(prev => ({ ...prev, scripPrice: parseFloat(rmdDetails.sRecoDetails[iIndex].EnteredPrice), scripQuantity: rmdDetails?.OrderCount }));
            } else if (
                rmdDetails.sRecoDetails[iIndex].nBuySell === 'SELL'
            ) {
                ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(prev => ({ ...prev, scripPrice: parseFloat(rmdDetails.sRecoDetails[iIndex].EnteredPrice), scripQuantity: rmdDetails?.OrderCount }));
            }
        }

        //For Entry and Stop Loss
        if ((rmdDetails.sRecoDetails[iIndex].SLPrice) > 0 && (rmdDetails.sRecoDetails[iIndex].SQPrice <= 0 || rmdDetails.sRecoDetails[iIndex].SQPrice === '')) {
            if (bIsCoverOrderAllowed) {//if cover is allowed for user
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, productType: ORDER_PRODUCT_TYPES.MARGIN, orderType: ORDER_ENTRY_TYPES.RL_MKT, isDefaultProductType: false }));
                productType = ORDER_PRODUCT_TYPES.MARGIN;
                productTypeDesc = ORDER_PRODUCT_TYPES.MARGIN;
                orderType = ORDER_ENTRY_TYPES.RL_MKT;
                ORDER_ENTRY_GRID_REF?.current?.setToggleBracketOrder({ isShow: true, strProductType: ORDER_PRODUCT_TYPES.COVER });
            } else {
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, orderType: ORDER_ENTRY_TYPES.RL_MKT, isDefaultProductType: false }));
            }
            ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(prev => ({ ...prev, intradayProfit: 0, intradayLimit: parseFloat(rmdDetails.sRecoDetails[iIndex].SLPrice), intradayTrigger: parseFloat(rmdDetails.sRecoDetails[iIndex].SLPrice) }));
        }
        //For Entry ,target and profit(square-off)
        else if ((rmdDetails.sRecoDetails[iIndex].SLPrice) > 0 && (rmdDetails.sRecoDetails[iIndex].SQPrice) > 0) {

            if (rmdDetails.sRecoDetails[iIndex].EnteredPrice !== '0') {
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, orderType: ORDER_ENTRY_TYPES.RL, }));
                orderType = ORDER_ENTRY_TYPES.RL;
            } else {
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, orderType: ORDER_ENTRY_TYPES.RL_MKT, }));
                orderType = ORDER_ENTRY_TYPES.RL_MKT;
            }

            ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(prev => ({ ...prev, intradayProfit: rmdDetails.sRecoDetails[iIndex].SQPrice, intradayLimit: rmdDetails.sRecoDetails[iIndex].SLPrice, intradayTrigger: rmdDetails.sRecoDetails[iIndex].SLPrice }));

            if (bIsBracketOrderAllowed) {//if bracket is allowed for user
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, productType: ORDER_PRODUCT_TYPES.MARGIN, productTypeDesc: ORDER_PRODUCT_TYPES.MARGIN, isDefaultProductType: false, }));
                productType = ORDER_PRODUCT_TYPES.MARGIN;
                productTypeDesc = ORDER_PRODUCT_TYPES.MARGIN;
                ORDER_ENTRY_GRID_REF?.current?.setToggleBracketOrder({ isShow: true, strProductType: ORDER_PRODUCT_TYPES.BRACKET });
            } else { }
        } else {
            if (rmdDetails.sRecoDetails[iIndex].EnteredPrice === '0' || rmdDetails.sRecoDetails[iIndex].EnteredPrice === '0.00' || rmdDetails.sRecoDetails[iIndex].EnteredPrice === '') {
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, orderType: ORDER_ENTRY_TYPES.RL_MKT, }));
                orderType = ORDER_ENTRY_TYPES.RL_MKT;
            } else {
                ORDER_ENTRY_GRID_REF?.current?.setSelectOrderOption(prev => ({ ...prev, orderType: ORDER_ENTRY_TYPES.RL, }));
                orderType = ORDER_ENTRY_TYPES.RL;
            }
        }
        dispatch(handleModalData({ data: { rowDetails: rmdDetails, scripLot: 0, scripQuantity: 0, orderType: orderType, productType: productType, productTypeDesc: productTypeDesc, SLPrice: rmdDetails?.sRecoDetails[0]?.SLPrice, scripPrice: rmdDetails?.EnteredPrice !== '0' ? rmdDetails?.EnteredPrice : rmdDetails?.sRecoDetails[0]?.SLPrice } }));
    }, [bIsBracketOrderAllowed, bIsCoverOrderAllowed, dispatch]);
    const onChangeGlobalSearch = useCallback((e) => {
        const strGlobalSearchText = e.target.value.toUpperCase();
        setStrGlobalSearchInputText(strGlobalSearchText);
        //BT-96728 - Global Search Feature : ManasaB : 22/07/2023 - Start
        if (strGlobalSearchText && strGlobalSearchText?.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            //BT-114263 : Removing "All" tab and Adding count in search tabs : ManasaB : 24/07/2023  Start
            //{/* BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End */ }
            dispatch(updateIsLoading(true));
            useDebounce(() => {
                dispatch(getSearchScrips(e?.target?.value?.toUpperCase(), -1, 0, 25, false));
            }, 1000);
            //{/* BT-118877 : Functional Implementation - Global Search : Vinit R : 09/10/2023 - End */ }
        }
        else {
            dispatch(setArrScripToBeAdded([]));

            dispatch(updateSearchScripDataStatusFailure({ status: true, strNoDataMessage: '' }));
        }
    }, [dispatch, setStrGlobalSearchInputText]);

    useEffect(() => {
        if (!strGlobalSearchInputText || strGlobalSearchInputText?.length < GLOBAL_SEARCH_MIN_LENGTH) {
            setIsSearchScrips(false);

        } else {
            setIsSearchScrips(true);
        }
    }, [strGlobalSearchInputText]);


    const handleSelectedPage = (e, selectedPage) => {
        setShow(false);// Hari K:12-02-2024 to close global search modal
        let searchArray = JSON.parse(getDecryptLocalStorage('RECENTLY_SEARCHED'));
        let objActiveUserRecentSearch = searchArray?.find((each) => each?.user_id === objLoginSession?.data?.user_id);
        if (searchArray?.length > 0) {
            if (objActiveUserRecentSearch && Object.keys(objActiveUserRecentSearch)?.length) {
                let nExistPageIndex = objActiveUserRecentSearch?.arrRecentScrips.findIndex(eachPage => eachPage.displayName === selectedPage.displayName);
                if (nExistPageIndex !== -1) {

                    objActiveUserRecentSearch.arrRecentScrips.splice(nExistPageIndex, 1);
                    const updatedUserSearch = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [selectedPage, ...objActiveUserRecentSearch?.arrRecentScrips] };
                    const indexOfObject = searchArray.findIndex((each) => each?.user_id === objLoginSession?.data?.user_id);
                    if (indexOfObject !== 1) {
                        searchArray[indexOfObject] = updatedUserSearch;
                    } else {
                        searchArray.push(updatedUserSearch);
                    }
                    dispatch(setArrRecentlySearchScrips(updatedUserSearch));
                    saveToLocalStorage(searchArray);
                }
                else {
                    const updatedUserSearch = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [selectedPage, ...objActiveUserRecentSearch?.arrRecentScrips] };
                    const indexOfObject = searchArray.findIndex((each) => each?.user_id === objLoginSession?.data?.user_id);
                    if (indexOfObject !== 1) {
                        searchArray[indexOfObject] = updatedUserSearch;
                    } else {
                        searchArray.push(updatedUserSearch);
                    }
                    dispatch(setArrRecentlySearchScrips(updatedUserSearch));
                    saveToLocalStorage(searchArray);
                }
            } else {
                const updatedUserSearch = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [selectedPage] };
                searchArray.push(updatedUserSearch);
                dispatch(setArrRecentlySearchScrips(updatedUserSearch));
                saveToLocalStorage(searchArray);

            }
        } else {
            const objeNewsUser = { user_id: objLoginSession?.data?.user_id, arrRecentScrips: [selectedPage] };
            const localArray = [objeNewsUser];
            dispatch(setArrRecentlySearchScrips(objeNewsUser));
            saveToLocalStorage(localArray);

        }

        if (selectedPage) {
            // Shuaib P. : 07-04-2023 : Common Function for global search and dash menu - Start
            hamburgerRoutes({ id: selectedPage?.id, route: selectedPage?.menuUrl }, navigate);
            // Shuaib P. : 07-04-2023 : Common Function for global search and dash menu - End

        } else { }
    };


    const onHandleGlobalIconClick = () => {
        if (setIsExpanded && setIsSideBar && setTabSearchToggle) {
            setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; });
            setIsSideBar(false);
            setTabSearchToggle(true);
        } else { }
        setTimeout(() => {
            dispatch(toastConfig({}));
        }, 50);
        dispatch(selectScripForDelete([]));
        _resetGridFeatures(WATCHLIST_GRID_REF);
        setShow(true); setStrGlobalSearchInputText('');
        handleTrending();
    };
    //BT-116977 : Implementing Add to Watchlist functionality : Manasa B : 13/09/2023 - Start
    const handleSearchScripDoneClick = () => {
        // globalScripDetails
        dispatch(setArrScripToBeAdded([...globalScripDetails]));
        setShow(false);
        dispatch(handleModal([{ "GLOBAL_SEARCH_ADDSCRIP_MODAL": true }]));
        setGlobalScripDetails([]);

    };
    //BT-116977 : Implementing Add to Watchlist functionality : Manasa B : 13/09/2023 - End

    const handleOverview = useCallback(async (arrRowData) => {
        const arrScrips = [{ mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(arrRowData.scripobj.MarketSegmentId)), token: arrRowData.scripobj.ODINCode }];
        const objResp = await getScripbyTokenAndMktSegId(arrScrips);
        const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
        let selectedScrips = gridFormatData[0];
        dispatch(setScripOverviewData(selectedScrips));
        dispatch(getExchangeWiseScripInfo(selectedScrips));
        dispatch(updateActiveOverViewTab('events'));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
        setShow(false);
    }, [dispatch]);



    const handleNewsOverview = useCallback(async (arrRowData) => {
        const arrScrips = [{ mkt: getApiExchangeNameFromMktSegId(getMktSegIdFromMappedMktSegId(arrRowData.nSegmentId)), token: arrRowData?.nToken }];
        const objResp = await getScripbyTokenAndMktSegId(arrScrips);
        const gridFormatData = convertScripResponseWatchlistGrid(objResp?.data?.result);
        let selectedScrips = gridFormatData[0];
        dispatch(setScripOverviewData(selectedScrips));
        dispatch(getExchangeWiseScripInfo(selectedScrips));
        dispatch(updateActiveOverViewTab('events'));
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
        setShow(false);
    }, [dispatch, setShow]);

    useLayoutEffect(() => {
        globalSearchRef?.current?.focus();
        const input = document.querySelector('input');
        if (input) {
            input.focus();
        }

    }, [globalSearchRef, show]);

    //Azeem K : 14-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo --Start
    const handleExploreModernAlgo = (LandingID) => {
        //BREEZE-16857 : LLD Comment:Created  onClick function of Explore Modern Algo click

        handleClickOnModernAlgo(dispatch, LandingID);

    };

    //Azeem K : 14-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo --End


    return (
        <>
            {isExpanded?.containerLength === SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT &&
                <div data-testid="global-search" className='global-search text-center d-flex align-items-center justify-content-center' onClick={onHandleGlobalIconClick}>
                    <Walkthrough orderNo={DASHBOAR_WALKTHROUGH_POPOVER_SEQUENCE.GLOBAL_SEARCH}>
                        <div data-testid='global-search-icon' className='icon-24 icon-search icon-light icon-rotate d-flex flex-shrink-0'></div>
                    </Walkthrough>
                </div>
            }
            {/* BT-96728 - Global Search Feature : ManasaB : 22/07/2023 - Start*/}
            {show &&
                //Vaibhav Singh: 23-11-23: GlobalSearch Leftclick ScripOverview implemented ref added: Start
                <div ref={wrapperRef} className={`global-search-wrapper ${isExpand ? 'global-search-wrapper-expand' : ''}`}>
                    {/* Vaibhav Singh: 23-11-23: GlobalSearch Leftclick ScripOverview implemented ref added: End */}
                    <div className='global-search-wrap'>
                        <Row className='g-0 global-search-header p-3'>
                            <Col className='d-flex justify-content-start'>
                                <div className='p-0 px-2 w-100 no-focus-textbox'>
                                    <BzInputText data-testid="global-search-input" ref={globalSearchRef} size='sm' type='input' value={strGlobalSearchInputText} className='p-0 bdr-none scripname-searchtext font-regular' placeholder='Search scrips' onChange={onChangeGlobalSearch} />
                                </div>
                                {strGlobalSearchInputText?.length >= 3 ? <Col md={1} className='d-flex align-items-center'><span data-testid="global-search-clear-button" className='font-medium color-text cursor-pointer text-end' onClick={() => { setStrGlobalSearchInputText(''); }}>Clear</span></Col> : null}
                            </Col>
                            <Col md="auto" className='d-flex justify-content-end align-items-center'>
                                <div data-testid="global-search-collapse-icon" className={`icon-16 ${isExpand ? "icon-collapse" : "icon-expand"} icon-grey ms-3`} onClick={handleExpand}></div>
                                <div data-testid="global-search-close-icon" className='icon-16 icon-close icon-grey ms-3' onClick={() => { setShow(false); setIsExpand(false); setGlobalScripDetails([]); }}></div>
                            </Col>
                        </Row>
                        <Row className={`g-0 global-search-content ${isExpand ? 'global-search-content-expand' : ''}`}>
                            <Col>

                                {/* Bhagyashri P [19-12-2023] : class changes for Global Search Feature Starts */}
                                {strGlobalSearchInputText?.length < GLOBAL_SEARCH_MIN_LENGTH &&
                                    <Container fluid className='p-0'>
                                        <Row className='g-0'>
                                            <Col>
                                                <div className={objCFT?.MODERN_ALGO_SUPPORT === FACILITY_NUM.ON ? `${isExpand ? 'global-search-trending-list-expand-algo-banner' : 'global-search-trending-list-collapse-algo-banner'}` : `${isExpand ? 'global-search-trending-list-expand' : 'global-search-trending-list-collapse'}`} >
                                                    {!isSearchScrips && <RecentSearch scrips={arrRecentlySearchScrips} isExpand={isExpand} onChangeGlobalSearch={onChangeGlobalSearch} isGlobal={true} onBuySellClick={onBuySellClick} addScrips={addGlobalScripsFromRecent} scripDetails={globalScripDetails} removeScrips={removeGlobalScrips} handleSelectedPage={handleSelectedPage} />}

                                                    {/* Vaibhav Singh: 22-11-23: Onchangevalue passed for Trending Search: Start */}
                                                    {!isSearchScrips && <TrendingSearch arrTrendingScrips={arrTrending} onChangeGlobalSearch={onChangeGlobalSearch} />}
                                                    {/* Vaibhav Singh: 22-11-23: Onchangevalue passed for Trending Search: End */}
                                                    {/* //Azeem K : 14-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo --Start
                                                        //BREEZE-16857 : LLD Comment:JSX of Explore modern Algo adding in Global Search   */}                                              </div>
                                                {objCFT?.MODERN_ALGO_SUPPORT === FACILITY_NUM.ON ?
                                                    <div className='trading-simplified-banner-card gap-3 mx-3' onClick={handleExploreModernAlgo?.bind(this, '1')}>
                                                        <div class="trading-simplified-icon-wrap">
                                                            <div class='icon-50 icon-algo-squar-logo'></div>
                                                        </div>
                                                        <div className='d-flex flex-column align-items-start w-100'>
                                                            <div className='d-inline-flex align-items-center gap-1'>
                                                                <div className='font-medium font-size3 color-active-text'>Trading Simplified</div>
                                                                <div class='icon-24 icon-star'></div>
                                                                <div className='font-medium font-size1 color-active-text'>ANYWHERE | ANYTIME</div>
                                                            </div>
                                                            <div className='font-regaular font-size2 trading-simplified-text-primary line-height-1'>All the goodness of Automation at your fingertips, invest and trade anywhere, anytime</div>
                                                            <div className='d-flex align-items-center justify-content-between mt-3 w-100'>
                                                                <button className='btn btn-sm btn-primary d-flex align-items-center justify-content-center'>Explore
                                                                    <div class="icon-14 icon-forward-arrow icon-light ms-2"></div>
                                                                </button>
                                                                <div class="icon-250 icon-modern-algo-logo icon-light"></div>
                                                            </div>

                                                        </div>
                                                    </div> : null}
                                            </Col>

                                            {/* //Azeem K : 14-11-2025 : BREEZE-16787 -  Breeze - Integration of Modern Algo --End */}

                                        </Row>
                                    </Container>
                                }
                                {/* Bhagyashri P [19-12-2023] : class changes for Global Search Feature Ends */}

                                <TabsScripsList
                                    // Ameersha N : 07-11-2023 : BT-96728 Global Search feature – Issue - addedScrips state not getting empty  – Start
                                    setScripDetails={setGlobalScripDetails} onBuySellClick={onBuySellClick} setNActiveCategory={setNActiveCategory}
                                    // Ameersha N : 07-11-2023 : BT-96728 Global Search feature – Issue - addedScrips state not getting empty  – End
                                    strSearchInputText={strGlobalSearchInputText} isSearchScrips={isSearchScrips} isGlobal={true}
                                    setStrGlobalSearchActiveTab={setStrGlobalSearchActiveTab} strGlobalSearchActiveTab={strGlobalSearchActiveTab}
                                    activeButtonToggleIndex={activeButtonToggleIndex} setActiveButtonToggleIndex={setActiveButtonToggleIndex} market={market} addScrips={addGlobalScrips} setMarket={setMarket} removeScrips={removeGlobalScrips} scripDetails={globalScripDetails}
                                    handleSelectSpreadOrderModel={handleSelectSpreadOrderModel} handleOnClickScrip={handleOnClickScrip} handleSelectedPage={handleSelectedPage} onBuySellClickRecomm={onBuySellClickRecomm}
                                    isDefaultAllTab={true} isGlobalSearch={true} onHandleDone={handleSearchScripDoneClick} isExpand={isExpand} handleEditAlert={handleEditAlert} handleNewsOverview={handleNewsOverview} handleOverview={handleOverview}
                                    setShow={setShow} //Added to close global search when clicked on Buy,Sell or other icons in tabs : ManasaB : 24/08/2023
                                />
                            </Col>
                        </Row>
                        {false &&
                            <Row className='g-0 global-search-footer bdt-top p-3'>
                                <Col>
                                    <div className=''>
                                        <form className='d-flex' onSubmit={(e) => e?.preventDefault()}>
                                            <Container fluid className='p-0'>
                                                <Row className='g-0'>
                                                    <Col md={10} className='d-flex justify-content-start align-items-center'>
                                                        {true ? globalScripDetails.length > 0 && <div className='font-regular font-size3 color-subtext me-2'>Add Selected Scrips</div> : <div className='font-regular font-size3 color-subtext me-2'>Add Scrip To</div>}
                                                        {/* <div className='font-medium font-size3 color-text text-uppercase me-2'>{strWatchlistName}</div> */}
                                                        {true ? globalScripDetails.length > 0 && <div className='number-badge'> {globalScripDetails?.length}</div> : <div className='number-badge'>{globalScripDetails?.length}</div>}
                                                    </Col>
                                                    <Col md={2} className='d-flex justify-content-end align-items-center'>
                                                        {true ? globalScripDetails.length > 0 && <BzButton className='btn btn-md btn-primary text-uppercase' onClick={handleSearchScripDoneClick}>Done</BzButton> : globalScripDetails.length > 0 && <BzButton className='btn btn-md btn-primary text-uppercase' onClick={handleSearchScripDoneClick}>Done</BzButton>}
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </form>
                                    </div>
                                </Col>
                            </Row>}
                    </div>
                </div>
            }
        </>
    );
};

export default memo(GlobalSearch);
// Maaz A : 27-02-2023 : BT-96728 - Breeze - Global Search Feature - End